import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

export interface MyProductsResultState {
    myProductsResult: any;
    productFilters: any;
    widgetId: string;
}

const initialState: MyProductsResultState = {
    myProductsResult: [],
    productFilters: {},
    widgetId: "",
};

const reducer = {
    "Custom/MyProducts/CompleteLoadMyProducts": (draft: Draft<MyProductsResultState>, action: { result: any }) => {
        draft.myProductsResult = action.result;
    },
    "Custom/MyProducts/SetMyProductFilters": (draft: Draft<MyProductsResultState>, action: any) => {
        draft.productFilters = { ...draft.productFilters, ...action.result };
    },
    "Custom/MyProducts/UpdateWidgetId": (draft: Draft<MyProductsResultState>, action: { result: any }) => {
        draft.widgetId = action.result;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
